var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.00390625,
    width: 8,
    height: 16.0011,
    rx: 3,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.99991,
    cy: 12.5527,
    r: 1.38578,
    fill: "#EE3E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67745 3.08232C2.6424 2.50718 3.09939 2.02148 3.6756 2.02148H4.32276C4.89897 2.02148 5.35596 2.50718 5.32091 3.08232L4.97967 8.68097C4.94807 9.19931 4.51848 9.60351 3.99918 9.60351C3.47987 9.60351 3.05029 9.19931 3.01869 8.68097L2.67745 3.08232Z",
    fill: "#EE3E54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 16,
    fill: "white",
    transform: "translate(8 16) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.1500a31ae209388a5ea794db5e138531.svg";
export { ForwardRef as ReactComponent };